<template>
  <button
    v-show="visible"
    type="button"
    class="clipboard-saved-toast"
    data-type="success"
    aria-live="polite"
    @click="dismiss"
  >
    <div
      class="clipboard-saved-toast__icon"
      data-icon=""
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        width="24"
        height="24"
        aria-hidden="true"
      >
        <circle
          cx="10"
          cy="10"
          r="10"
          fill="#111827"
        />
        <path
          fill="#fff"
          fill-rule="evenodd"
          d="M13.477 7.823a.75.75 0 0 1 .042 1.052l-3.928 4.284a.75.75 0 0 1-1.086.004l-2.09-2.308a.75.75 0 1 1 1.108-1.012l1.54 1.7 3.41-3.72a.75.75 0 0 1 1.052-.042Z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <div
      class="clipboard-saved-toast__content"
      data-content=""
    >
      <div
        class="clipboard-saved-toast__title"
        data-title=""
      >
        Saved to Clipboard
      </div>
      <div
        class="clipboard-saved-toast__description"
        data-description=""
      >
        {{ description }}
      </div>
    </div>
  </button>
</template>

<script>
const DEFAULT_DURATION_MS = 5000;

export default {
  name: 'ClipboardSavedToast',

  data() {
    return {
      visible: false,
      timerId: null,
      // Reflects how many prompts were just saved — plural when a single action
      // saves more than one (e.g. both A/B variant prompts). (POR-13583)
      description: 'Saved prompt added to your Clipboard panel.',
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$el && this.$el.parentNode !== document.body) {
        this._portalParent = this.$el.parentNode;
        document.body.appendChild(this.$el);
      }
    });
  },

  beforeDestroy() {
    this.clearTimer();
    if (this.$el?.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },

  methods: {
    show(durationMs = DEFAULT_DURATION_MS, count = 1) {
      this.description = count > 1
        ? `${count} prompts added to your Clipboard panel.`
        : 'Saved prompt added to your Clipboard panel.';
      this.clearTimer();
      this.visible = true;
      this.timerId = window.setTimeout(() => {
        this.visible = false;
        this.timerId = null;
      }, durationMs);
    },

    dismiss() {
      this.clearTimer();
      this.visible = false;
    },

    clearTimer() {
      if (this.timerId) {
        window.clearTimeout(this.timerId);
        this.timerId = null;
      }
    },
  },
};
</script>

<style scoped>
.clipboard-saved-toast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 10060;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 356px;
  max-width: calc(100vw - 48px);
  margin: 0;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #111827;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
  text-align: left;
  cursor: pointer;
  animation: clipboard-saved-toast-in 200ms ease;
}

@keyframes clipboard-saved-toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.clipboard-saved-toast__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.clipboard-saved-toast__icon svg {
  display: block;
  width: 20px;
  height: 20px;
}

.clipboard-saved-toast__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.clipboard-saved-toast__title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  color: #111827;
}

.clipboard-saved-toast__description {
  font-size: 13px;
  line-height: 1.35;
  color: #6b7280;
}
</style>
